const state = {
  ws: undefined,
  newMessage: {},
  onMessagefn: []
}

const getters = {
  getWs: state => state.ws,
  getNewMessage: state => state.newMessage
}

const actions = {
  'ADD_FN': ({ state }, fn) => {
    let id = Math.random().toString(36).substr(2, 9)
    state.onMessagefn.push({ [id]: fn })
    return id
  }
}

const mutations = {
  'CONNECTION_SERVER': (state) => {
    // demande de notif HTML5
    if ('Notification' in window) {
      if (Notification.permission === 'default') {
        Notification.requestPermission(function (permission) {
          if (!('permission' in Notification)) {
            Notification.permission = permission
          }
        })
      }
    }

    // Socket
    state.ws = new WebSocket(process.env.VUE_APP_WS_URL)
    state.ws.onmessage = (notif) => {
      for (let fns of state.onMessagefn) {
        for (let fnObject of Object.values(fns)) {
          fnObject.fn(notif)
        }
      }
      // state.newMessage = notif
    }
  },
  'REMOVE_FN': (state, id) => {
    for (let k in state.onMessagefn) {
      if (state.onMessagefn[k][id]) {
        delete state.onMessagefn[k][id]
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
